<template>
  <footer class="bg-gray-100 py-6 mt-auto">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center">
        <div class="text-sm text-gray-600">
          © {{ currentYear }} 笔记应用. All rights reserved.
        </div>
        <div class="space-x-4 text-sm">
          <router-link to="/privacy" class="text-gray-600 hover:text-gray-900">
            隐私政策
          </router-link>
          <router-link to="/help" class="text-gray-600 hover:text-gray-900">
            <i class="fas fa-question-circle mr-1"></i> 帮助
          </router-link>
          <router-link to="/terms" class="text-gray-600 hover:text-gray-900">
            <i class="fas fa-file-contract mr-1"></i> 使用条款
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())
    
    return {
      currentYear
    }
  }
}
</script> 